import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60c76bcb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "customer-booking-page" }
const _hoisted_2 = {
  key: 0,
  class: "timeline-chart"
}
const _hoisted_3 = { class: "customer-booking-content" }

import { useRouter } from "vue-router";
import BookingStepsHeader from "../components/BookingStepsHeader.vue";
import RouterConstants from "../constants/router.constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingWrapper',
  setup(__props) {

const router = useRouter();

let showTimeLine = () => {
  const disbleStepHeaderRouters = [
    RouterConstants.BOOKING_CANCEL_SUCCESS_ROUTER_NAME,
    RouterConstants.BOOKING_SUCCESS_ROUTER_NAME,
  ];

  return !disbleStepHeaderRouters.includes(router.currentRoute.value.name);
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showTimeLine)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(BookingStepsHeader)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})